module.exports = __webpack_public_path__ + "static/media/classics-2-2.4c12abf2.jpg";